import React from "react";

const ExamWatermark: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-10">
      <div 
        className="text-gray-500 text-8xl font-bold select-none"
        style={{ 
          opacity: 0.1, 
          transform: 'rotate(-45deg)',
          whiteSpace: 'nowrap'
        }}
      >
        S&S ACADEMY
      </div>
    </div>
  );
};

export default ExamWatermark; 